import { RESET_GRAPHICAL_STATISTICS } from './types';

export const resetGraphicalStatistics = () => ({ type: RESET_GRAPHICAL_STATISTICS });
